<template>
	<i18n-t keypath="baselines.brdcRequiredInfo" tag="span" scope="global">
		<template #brdc>
			<router-link class="link" :to="{ name: 'settings-type', params: { id: 'external-sources' } }">{{ $t('baselines.brdcRequiredInfoLink') }}</router-link>
		</template>
	</i18n-t>
</template>

<script>
export default {
	components: {
	},
};
</script>

<style scoped>
.link {
	text-decoration: underline;
}
</style>
